import * as constants from "./../constants";
export const setAllDonors = (data) => ({
  type: constants.SET_ALL_DONORS,
  payload: data,
});
